<template>
    <default-input input-label="Фактическая дата"
      input-name="actual_date"
      v-slot="{id}"
      :errors="errors"
      :class="'col-md-4'"
    >
      <date-picker
        v-model="actualDate"
        v-facade="'##.##.####'"
        format="DD.MM.YYYY"
        :id="id"
        :value-type="'format'"
        :disabled="disableDateInput"
        :disabled-date="disabledDate"
      />
      <slot name="after">
      </slot>
    </default-input>
</template>

<script>
import DefaultInput from '@/components/application/form-inputs/DefaultInput.vue';
import applicationFormMixin from '@/common/mixins/applicationFormMixin';
import moment from 'moment/moment'
import { mapMutations, mapState } from 'vuex';
import { UserRoles } from '@/common/enums/UserRoles'
import { ApplicationStatuses } from '@/common/enums/ApplicationStatuses'

export default {
  name: 'ActualDateBlock',
  components: { DefaultInput },
  mixins: [
    applicationFormMixin
  ],

  computed: {
    ...mapState('vtsApplication', {
      actual_date: state => state.application.actual_date,
      appId: state => state.application.id,
      application: state => state.application
    }),

    actualDate: {
      get () {
        return this.actual_date
      },
      set (actual_date) {
        this.setApplication({ actual_date })
      }
    },

    disableDateInput () {
      return this.disabledInput && (this.user.role !== UserRoles.DISPATCHER || this.application.status !== ApplicationStatuses.AWAITING)
    }
  },

  mounted () {
    if (this.actualDate === null) {
      this.actualDate = new Date(Date.now()).toLocaleString()
    }
  },

  methods: {
    ...mapMutations('vtsApplication', [
      'setApplication'
    ]),

    disabledDate (date) {
      return date > moment()
    }
  }
};
</script>
